export const prefixCdnUrl = (cdnUrl, ids, images) =>
  ids.reduce((acc, id) => {
    return {
      ...acc,
      [id]: `${cdnUrl}${images[id]}`,
    };
  }, {});

export const getAssetSet = (cb, filename) => {
  const assets = cb(filename);

  if (Array.isArray(filename) && filename.length === 1) {
    return assets[filename[0]];
  }

  if (Array.isArray(filename)) {
    return assets;
  }

  return assets[filename];
};
